import React from 'react';

// Common reusable components
import HelpVideo from '../HelpVideo';
import ComponentHelpDetails from '../ComponentHelpDetails';
import SliderWithVideo from '../SliderWithVideo';
import InstructionScrollField from '../InstructionScrollField';

const SubconsPage = () => {
    return(
        <div className="">
            <SliderWithVideo 
                idName="rav-subcontractors"
                title="Managing Subcontractors"
                video={<HelpVideo link="https://www.youtube.com/embed/y4lzIIbfoJs" title="RAV - Subcontractors Tutorial" />}
            >
                
            </SliderWithVideo>
        </div>
    );
};

export default SubconsPage;
